import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import {ROLECOLOR} from '../../../Templates/data'
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
    maxWidth: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 500,
        }
    },
    getContentAnchorEl: () => null
};

export default function SelectBox(props) {
  const classes = useStyles();
  const handleChange = (event) => {
    props.modifyRole(event.currentTarget.innerText)
  };
  return (
    <div >
      <FormControl className={`flex-centered ${classes.formControl}`}>
        <InputLabel id="demo-simple-select-label">Role</InputLabel>
        <Select
          id="demo-simple-select"
          value={props.currentRole}
          MenuProps={MenuProps}
          renderValue={() => {
            return props.currentRole
          }}
          onChange={handleChange}
          style={{width: "100%"}}
        >
              {Object.keys(ROLECOLOR).filter(role => role !== "Production Controller" && role !== "Production Controllers").map((role => {
                        return <MenuItem key={role} value={role}>
                            <Checkbox checked={(props.currentRole === role)} />
                            <ListItemText primary={role} />
                        </MenuItem>
                    }))}
        </Select>
      </FormControl>
    </div>
  );
}
